const KEY = (topicId) => `dalas_quiz_attempts_topic_${topicId}`;
const MAX_STORED = 5;

export function getAttempts(topicId) {
  try {
    return JSON.parse(localStorage.getItem(KEY(topicId))) ?? [];
  } catch {
    return [];
  }
}

export function saveAttempt(topicId, result) {
  try {
    const prev = getAttempts(topicId);
    const entry = {
      date: new Date().toISOString(),
      score: result.score,
      total: result.total,
      answers: result.answers,
    };
    const updated = [entry, ...prev].slice(0, MAX_STORED);
    localStorage.setItem(KEY(topicId), JSON.stringify(updated));
  } catch {
    // localStorage unavailable (e.g. private mode) — silently ignore
  }
}
